import React from 'react';
import EnhancedTableBase from '../../../components/common/EnhancedTable/EnhancedTableBase';
import { EnhancedTableProps } from '../../../components/common/EnhancedTable/types';
import '../../../components/common/EnhancedTable/EnhancedTableFix.css';
import './EnhancedRentalContracts.css';

/**
 * EnhancedRentalContractsTable component
 * 
 * This component extends the EnhancedTableBase component with specific styling and behavior
 * for the Rental Contracts page.
 */
function EnhancedRentalContractsTable<T extends Record<string, any>>(props: EnhancedTableProps<T>) {
  return (
    <EnhancedTableBase
      {...props}
      className={`enhanced-table-force-scroll ${props.className || ''}`}
      defaultSort={props.defaultSort}
      onSort={props.onSort}
    />
  );
}

export default EnhancedRentalContractsTable;
